import {
    Button,
    Command,
    CommandEmpty,
    CommandGroup,
    CommandInput,
    CommandItem,
    CommandList,
    Popover,
    PopoverContent,
    PopoverTrigger,
    Skeleton,
} from '@repo/shadcn';
import { ChevronsUpDown } from 'lucide-react';
import { useEffect, useState } from 'react';
import { useController } from 'react-hook-form';

import { useGetTypesQuery } from '../../../../../features/slice/products/type/type-api-slice';

export function TypeAutoComplete({ control, name }: any) {
    const [open, setOpen] = useState(false);
    const [searchTerm, setSearchTerm] = useState('');
    const [debouncedSearchTerm, setDebouncedSearchTerm] = useState('');

    useEffect(() => {
        const handler = setTimeout(() => {
            setDebouncedSearchTerm(searchTerm);
        }, 500);

        return () => {
            clearTimeout(handler);
        };
    }, [searchTerm]);

    const { data: searchData, isLoading } = useGetTypesQuery({
        limit: 10,
        page: 1,
        search: debouncedSearchTerm || undefined,
        sort_order: 'asc',
    });

    const handleSearchInput = (value: string) => {
        setSearchTerm(value);
    };

    const { field } = useController({ name, control });

    const selectedType = searchData?.data?.find(
        (type: any) => type.id === field.value,
    );

    useEffect(() => {
        if (!field.value && searchData?.data?.length) {
            // If the field has no value, and data exists, set a default one if needed
            field.onChange(searchData.data[0]?.id);
        }
    }, [searchData, field]);
    if (isLoading) {
        return <Skeleton className="mt-2 h-[40px] w-full" />;
    }

    return (
        <div id="portal-root">
            <Popover open={open} onOpenChange={setOpen}>
                <PopoverTrigger asChild>
                    <Button
                        variant="outline"
                        role="combobox"
                        aria-expanded={open}
                        className="w-full justify-between   truncate"
                    >
                        <p className="w-[90%] truncate duration-300">
                            {selectedType
                                ? selectedType.name
                                : 'Select type...'}
                        </p>
                        <ChevronsUpDown className="ml-2 h-4 w-4 shrink-0 opacity-50" />
                    </Button>
                </PopoverTrigger>
                <PopoverContent>
                    <Command className="relative w-[300px]">
                        <CommandInput
                            value={searchTerm}
                            onValueChange={handleSearchInput}
                            placeholder="Search type..."
                            className="truncate"
                        />
                        <CommandList>
                            <CommandEmpty>No type found.</CommandEmpty>
                            <CommandGroup>
                                {searchData?.data?.map((type: any) => (
                                    <CommandItem
                                        key={type.id}
                                        value={type.name}
                                        onSelect={() => {
                                            field.onChange(type.id);
                                            setOpen(false);
                                        }}
                                        className="border-b-[1px]"
                                    >
                                        {type.name}
                                    </CommandItem>
                                ))}
                            </CommandGroup>
                        </CommandList>
                    </Command>
                </PopoverContent>
            </Popover>
        </div>
    );
}
